export default __webpack_public_path__ + "static/media/Cover.d2d608b5.png";